import { render, staticRenderFns } from "./HotControls.vue?vue&type=template&id=6b7c29b2&scoped=true&"
import script from "./HotControls.vue?vue&type=script&lang=js&"
export * from "./HotControls.vue?vue&type=script&lang=js&"
import style0 from "./HotControls.vue?vue&type=style&index=0&id=6b7c29b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7c29b2",
  null
  
)

export default component.exports